function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M68.53 54.7268C68.53 53.6222 67.6346 52.7268 66.53 52.7268H58.4087C57.3041 52.7268 56.4087 53.6222 56.4087 54.7268V60.5514C56.4087 61.656 57.3041 62.5514 58.4087 62.5514H66.53C67.6346 62.5514 68.53 61.656 68.53 60.5514V54.7268Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M68.53 77.0877C68.53 75.9832 67.6346 75.0877 66.53 75.0877H58.4087C57.3041 75.0877 56.4087 75.9832 56.4087 77.0877V82.9123C56.4087 84.0169 57.3041 84.9123 58.4087 84.9123H66.53C67.6346 84.9123 68.53 84.0169 68.53 82.9123V77.0877Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M56.4087 99.4485C56.4087 98.344 57.3041 97.4485 58.4087 97.4485H66.53C67.6346 97.4485 68.53 98.344 68.53 99.4486V105.273C68.53 106.378 67.6346 107.273 66.53 107.273H58.4087C57.3041 107.273 56.4087 106.378 56.4087 105.273V99.4485Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M92.4692 65.9073C92.4692 64.8027 91.5738 63.9073 90.4692 63.9073H82.3479C81.2433 63.9073 80.3479 64.8027 80.3479 65.9073V71.7319C80.3479 72.8365 81.2433 73.7319 82.3479 73.7319H90.4692C91.5738 73.7319 92.4692 72.8365 92.4692 71.7319V65.9073Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M80.3479 88.2681C80.3479 87.1636 81.2433 86.2681 82.3479 86.2681H90.4692C91.5738 86.2681 92.4692 87.1636 92.4692 88.2681V94.0928C92.4692 95.1973 91.5738 96.0928 90.4692 96.0928H82.3479C81.2433 96.0928 80.3479 95.1973 80.3479 94.0928V88.2681Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M116.409 77.0877C116.409 75.9832 115.513 75.0877 114.409 75.0877H106.287C105.183 75.0877 104.287 75.9832 104.287 77.0877V82.9123C104.287 84.0169 105.183 84.9123 106.287 84.9123H114.409C115.513 84.9123 116.409 84.0169 116.409 82.9123V77.0877Z",
  fill: "white"
});

function SvgCoinIconLpt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIconLpt);
export default __webpack_public_path__ + "static/media/CoinIconLPT.de4a6c4b.svg";
export { ForwardRef as ReactComponent };